// extracted by mini-css-extract-plugin
export default {"root":"lRZiZ","circle":"MME0s","spinAnimation":"mYE1u","spinAnimation-rtl":"_rpXs","circleIsXSmall":"klUGI","circleIsSmall":"Sy_x_","circleIsMedium":"zbLyN","circleIsLarge":"GuMyi"};